import { useParams } from "react-router-dom";
import { FormActions } from "../../components/common/FormActions";
import {
  API_CUSTOMER_CONFIGURABLE_MERCHANTS,
  API_MECHANT_FEES,
} from "../../utils/apis";
import {
  beautify,
  // createEditAction,
  // createViewAction,
  createViewEdit,
  // formatCurrency,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_MERCHANT_FEES } from "../../utils/urls";
import useGet from "../common/useGet";
import { useEffect } from "react";

const url = URL_MERCHANT_FEES;

// REGISTER
export const useMerchantFees = () => {
  const { id } = useParams<{ id?: string }>();
  const tableColumns = () => [
    {
      id: "merchant_name",
      header: "Merchant Name",
      filter: {},
    },
    {
      id: "merchant_code",
      header: "Merchant Code",
      filter: {},
    },
    {
      id: "fee",
      header: "Fee",
      filter: {
        type: "number",
        placeholder: "Enter amount...",
      },
    },
    {
      id: "fee_type",
      header: "Fee Type",
      filter: {
        type: "select",
        placeholder: "Select fee type...",
        options: [
          { id: "FIXED", name: "Fixed" },
          { id: "PERCENTAGE", name: "Percentage" },
          { id: "TIERED", name: "Tiered" },
        ],
      },
    },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        fee_type: beautify(item?.fee_type),
        fee_amount: item?.fee_amount,
        actions: <FormActions actions={[...createViewEdit(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Fees Details",
          fields: {
            ...item,
            fee_type: beautify(item?.fee_type),
            fee_amount: item?.fee_amount,
            is_percent: item?.is_percent ? "True" : "False",
            is_active: item?.is_active ? "True" : "False",
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);
  const endpoint = `transact/merchant-fees/${id}/logs/`;

  return { tableData, tableColumns, formRoute, viewData, endpoint };
};

// FORM
export const useMerchantFeesForm = ({ form }) => {
  const {
    loadData: getConfigurableMerchants,
    data: configurableMerchants,
    loading: configurableMerchantsLoading,
  } = useGet();

  useEffect(() => {
    getConfigurableMerchants({ api: API_CUSTOMER_CONFIGURABLE_MERCHANTS });
  }, []);

  const sections: any = [
    {
      title: "Merchant Fees Details",
      fields: [
        {
          field_name: "merchant_name",
          label: "Merchant Name",
          type: "select",
          props: {
            required: true,
          },
          options_data: configurableMerchants?.map((item: any) => ({
            id: item?.id,
            name: item?.name,
            extraFields: {
              merchant_code: item.id,
            },
          })),
        },
        {
          field_name: "merchant_code",
          label: "Merchant Code",
          type: "text",
          props: {
            required: true,
            disabled: true,
            value: form?.merchant_code || "",
          },
        },
        {
          field_name: "fee_type",
          type: "select",
          label: "Fee Type",
          props: { required: true },
          options_data: [
            { id: "FIXED", name: "Fixed" },
            { id: "PERCENTAGE", name: "Percentage" },
            { id: "TIERED", name: "Tiered" },
          ],
        },
        {
          field_name: "fee_amount",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "lower_limit",
          label: "Lower Limit",
          type: "decimal",
          props: { required: true, min: 0 },
          visible: form?.fee_type === "TIERED",
        },
        {
          field_name: "upper_limit",
          label: "Upper Limit",
          type: "decimal",
          props: { required: true, min: 0 },
          visible: form?.fee_type === "TIERED",
        },

        {
          field_name: "is_percent",
          type: "select",
          label: "Is Percentage",
          props: { required: true },
          visible:
            form?.fee_type === "TIERED" || form?.fee_type === "PERCENTAGE",
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "is_active",
          type: "select",
          label: "Is Active",
          props: { required: true },
          visible: form?.fee_type === "PERCENTAGE",
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  return {
    sections,
    redirect,
    onSubmit: submitMerchantFees,
    configurableMerchantsLoading,
  };
};

// SUBMIT
export function submitMerchantFees(payload: any, id: string | number) {
  //   UPDATE
  if (id) {
    return {
      api: `${API_MECHANT_FEES}${id}/update_fee/`,
      params: {
        ...payload,
      },
    };
  }

  //   CREATE
  return {
    api: `${API_MECHANT_FEES}create_fee/`,
    params: {
      ...payload,
    },
  };
}
